import { useState } from "react";

/**
 * 自评相关状态管理 Hook
 */
const useSelfAssessmentState = () => {
  const [selfAssessmentStatus, setSelfAssessmentStatus] = useState(null);
  const [showSelfAssessmentIcon, setShowSelfAssessmentIcon] = useState(false);
  const [shouldBlinkIcon, setShouldBlinkIcon] = useState(false);

  // 批量更新自评状态
  const updateSelfAssessmentState = (data) => {
    if (data.status !== undefined) setSelfAssessmentStatus(data.status);
    if (data.showIcon !== undefined) setShowSelfAssessmentIcon(data.showIcon);
    if (data.shouldBlink !== undefined) setShouldBlinkIcon(data.shouldBlink);
  };

  // 重置自评状态
  const resetSelfAssessmentState = () => {
    setSelfAssessmentStatus(null);
    setShowSelfAssessmentIcon(false);
    setShouldBlinkIcon(false);
  };

  return {
    selfAssessmentStatus,
    setSelfAssessmentStatus,
    showSelfAssessmentIcon,
    setShowSelfAssessmentIcon,
    shouldBlinkIcon,
    setShouldBlinkIcon,
    updateSelfAssessmentState,
    resetSelfAssessmentState,
  };
};

export default useSelfAssessmentState;
